import { Pipe, PipeTransform, inject } from '@angular/core';
import { ConfigurationService } from '@interacta-shared/data-access-configuration';
import { formatDistanceToNow, type Locale } from 'date-fns';

/**
 * See https://injenia.atlassian.net/l/cp/r6L3KnZu
 */
@Pipe({
    name: 'notificationDate',
})
export class NotificationDatePipe implements PipeTransform {
    private configurationService = inject(ConfigurationService);

    locale!: Locale;

    constructor() {
        this.configurationService
            .getLocaleDateFns()
            .subscribe((locale) => (this.locale = locale));
    }

    transform(date: Date): string {
        return formatDistanceToNow(date, {
            addSuffix: true,
            locale: this.locale,
        });
    }
}
